import React from "react";
import { LuCircleArrowRight, LuFileText, LuGraduationCap } from "react-icons/lu";
import "./quickAccess.css";

const quickAccessItems = [
  {
    title: "Admission A.Y. 2026 - 2027 Enquiry",
    description: "Submit your details for admission enquiry",
    href: "https://docs.google.com/forms/d/e/1FAIpQLSd0dLe-TkhA4QeZ2SEEHBVaCaHwZ5Dp-K_4_HY2FFHqcrt1ug/viewform",
    icon: LuGraduationCap,
  },
  {
    title: "Admission Process",
    description: "Step-by-step guide to begin your journey",
    href: "/admission-procedure-2",
    icon: LuFileText,
  },
];

function QuickAccess({ items = quickAccessItems, className = "" }) {
  return (
    <section className={`quick-access-section ${className}`} aria-labelledby="quick-access-title">
      <div className="quick-access-card">
        <div className="quick-access-pattern" aria-hidden="true" />

        <h2 id="quick-access-title" className="quick-access-title">
          <span aria-hidden="true">•</span> QUICK ACCESS
        </h2>

        <div className="quick-access-grid">
          {items.map((item) => {
            const Icon = item.icon;
            const content = (
              <>
                <span className="quick-access-icon" aria-hidden="true">
                  <Icon />
                </span>

                <span className="quick-access-copy">
                  <strong>{item.title}</strong>
                  <small>{item.description}</small>
                </span>

                <span className="quick-access-arrow" aria-hidden="true">
                  <LuCircleArrowRight />
                </span>
              </>
            );

            return item.href && item.href !== "#" ? (
              <a className="quick-access-item" href={item.href} key={item.title}>
                {content}
              </a>
            ) : (
              <button className="quick-access-item" type="button" key={item.title}>
                {content}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default QuickAccess;